import { Image } from '../../../AbstractElements'
import { NavLink } from 'reactstrap'
import { dynamicImage } from '../../../Utils'
import { navLinkList } from '../../../Data/Layout/ThemeCustomizerData'

const NavLinks = () => {
  return (
    <>
      {navLinkList &&
        navLinkList.map((item, index) => (
          <NavLink key={index} href={item.path} target="_blank">
            <div>
              <Image src={dynamicImage(`customizer/${item.image}`)} alt="icons" />
            </div>
            <span>{item.name}</span>
          </NavLink>
        ))}
    </>
  )
}

export default NavLinks